<ng-content select="[before-user]"></ng-content>
<div class="avatar-container" [style.width.px]="avatarSize" [style.height.px]="avatarSize">
	<nha-avatar
		[type]="userType"
		[guid]="userGUID"
		[size]="avatarSize"
		[ngClass]="{ 'hover-hide': withCheckbox, 'user-checked': checked }"
		[showSelfPacedBadge]="showSelfPacedBadge"
	>
	</nha-avatar>
	@if (withCheckbox) {
		<mat-checkbox
			[checked]="checked"
			[disabled]="checkboxDisabled"
			(change)="onCheckboxClicked($event)"
			nhaTest="select-person"
			[ngClass]="{ 'user-checked': checked }"
		>
		</mat-checkbox>
	}
</div>

@if (linkUrl) {
	<a [href]="linkUrl" [attr.target]="newTab ? '_blank' : null" [ngClass]="{ 'with-checkbox': withCheckbox }">
		<span [ngClass]="{ isLink: linkUrl }" [title]="userDisplayName" class="user-name" nhaTest="person-name"> {{ userDisplayName }} </span>
	</a>
}

@if (routeUrl) {
	<a [routerLink]="routeUrl" [ngClass]="{ 'with-checkbox': withCheckbox }">
		<span [ngClass]="{ isLink: routeUrl }" [title]="userDisplayName" class="user-name" nhaTest="person-name"> {{ userDisplayName }} </span>
	</a>
}

@if (!routeUrl && !linkUrl) {
	<span class="user-name" nhaTest="person-name" [ngClass]="{ 'with-checkbox': withCheckbox }" (click)="userClicked.emit(userID)">
		{{ userDisplayName }}
	</span>
}

<ng-content></ng-content>
